module.exports = __webpack_public_path__ + "img/扫码盘点.57f5869d.svg";